<template>
    <div class="side-area">
        <brand-or-vendor :serailRightData=serailData :brandOrVendorData=brandOrVendorData></brand-or-vendor>
        <may-concern :RightCarsConcern=carsConcern :brandOrVendorConcern=brandOrVendorConcern :aSid=aSid></may-concern>
        <conditions :propsOtherBaike=propsOtherBaike></conditions>
        <tags :relateTagWord=relateTagWord :propP=pageNo></tags>
        <club :clueData=clueData></club>
        <hot :propHot=propHot :propP=pageNo></hot>
    </div>
</template>

<script>
import BrandOrVendor from './BrandOrVendor.vue';
import MayConcern from './MayConcern.vue';
import Conditions from './Conditions.vue';
import Club from './Club.vue';
import Tags from './Tags.vue';
import Hot from './Hot.vue';
export default {
    components: { BrandOrVendor, MayConcern, Conditions,Club, Tags, Hot },
    name: 'Common',
    props: {
        serailRightData: {
            type: Object,
            default: () => ({})
        },
        RightCarsConcern: {
            type: Array,
            default: () => ([])
        },
        RightBrandOrVendorMyConcern: {
            type: Array,
            default: () => ([])
        },
        brandOrVendorRightData: {
            type: Object,
            default: () => ({})
        },
        propsOtherBaike: {
            type: Array,
            default: () => ([])
        },
        propsClueData: {
            type: Array,
            default: () => ([])  
        },
        propsRelateTagWord: {
            type: Array,
            default: () => ([])
        },
        propsRightHots: {
            type: Array,
            default: () => ([])
        },
        propsCurrentPage: {
            type: Number,
            default: 0,
        },

        propsASid:{
            type:String,
            default:""
        }

    },
    data() {
        return {
            serailData: {}, //车系数据

            brandOrVendorData: {}, //品牌或厂商数据

            carsConcern: [], //可能关注数据

            brandOrVendorConcern: [], //可能关注品牌或厂商

            otherBaike: [], //百科数据

            clueData: [], //右侧车友会

            relateTagWord: [], //相关标签

            propHot: [], //右侧热门数据

            pageNo: 1, //当前页面第几页

            aSid:""
        }
    },
    watch:{
        serailRightData(n) {
            this.serailData = n
        },
        RightCarsConcern(n) {
            this.carsConcern = n
        },
        brandOrVendorRightData(n) {
            this.brandOrVendorData = n
        },
        RightBrandOrVendorMyConcern(n) {
            this.brandOrVendorConcern = n
        },
        propsOtherBaike(n) {
            this.otherBaike = n
        },
        propsClueData(n) {
            this.clueData = n
        },
        propsRelateTagWord(n) {
            this.relateTagWord = n
        },
        propsRightHots(n) {
            this.propHot = n
        },
        propsCurrentPage(n) {
            this.pageNo =n
        },
        propsASid(n) {
            this.aSid = n
        }
    }
};
</script>

<style lang="scss" scoped>
.side-area {
  width: 310px;
//   position: absolute;
//   right: -380px;
//   top: 0;
}
</style>
